/* JOIEX theme.js (v5)
   Shopper-facing text comes from window.JX_STR (snippets/js-strings.liquid).
   Nothing customer-visible is hard-coded here. */
(function () {
  'use strict';

  var STR = window.JX_STR || {};

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function qa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
  }
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  function visibleFocusables(root) {
    return qa(FOCUSABLE, root).filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }
  // keep Tab / Shift+Tab inside an open dialog
  function trapTab(e, root) {
    if (e.key !== 'Tab' || !root) return;
    var items = visibleFocusables(root);
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || !root.contains(active))) { focusEl(last); e.preventDefault(); }
    else if (!e.shiftKey && (active === last || !root.contains(active))) { focusEl(first); e.preventDefault(); }
  }

  // ---- mobile drawer ----
  var burger = document.querySelector('[data-burger]');
  var drawer = document.querySelector('[data-mobile-nav]');
  var scrim = document.querySelector('[data-mobile-scrim]');
  var drawerReturnFocus = null;
  function isDrawerOpen() { return !!(drawer && drawer.classList.contains('open')); }
  // The drawer lives inside the sticky header section (its own stacking context),
  // so body-level overlays such as the promo slide-up bar would paint over it.
  // Flag the open state on <html> and announce it so the promo can step aside.
  function setDrawerState(open) {
    document.documentElement.classList.toggle('jx-drawer-open', open);
    try { document.dispatchEvent(new CustomEvent('jx:drawer', { detail: { open: open } })); } catch (err) {}
  }
  function openDrawer() {
    if (!drawer) return;
    drawerReturnFocus = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setDrawerState(true);
    focusEl(drawer.querySelector('[data-drawer-close]'));
  }
  function closeDrawer() {
    if (!drawer) return;
    var wasOpen = isDrawerOpen();
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (wasOpen) setDrawerState(false);
    if (wasOpen && drawerReturnFocus && document.body.contains(drawerReturnFocus)) focusEl(drawerReturnFocus);
    drawerReturnFocus = null;
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);
  qa('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) {
    if (!isDrawerOpen()) return;
    // claim Escape so later listeners (the promo) do not also act on it
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    trapTab(e, drawer);
  });
  if (window.matchMedia) {
    var desktopMq = window.matchMedia('(min-width: 991px)');
    var onDesktop = function (ev) { if (ev.matches && isDrawerOpen()) closeDrawer(); };
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', onDesktop);
    else if (desktopMq.addListener) desktopMq.addListener(onDesktop);
  }

  // ---- product gallery (swipeable carousel + thumbs + dots) ----
  qa('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.gallery-slide');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var dots = g.querySelectorAll('[data-dot]');
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    var last = slides.length - 1;
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('sel', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        // keep the active thumb in view now that the rail scrolls horizontally
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          var tr = t.getBoundingClientRect(), pr = t.parentNode.getBoundingClientRect();
          if (tr.left < pr.left || tr.right > pr.right) {
            t.parentNode.scrollTo({ left: t.offsetLeft - (pr.width - tr.width) / 2, behavior: 'smooth' });
          }
        }
      });
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= last;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(last, i));
      // the stylesheet's prefers-reduced-motion rule cannot reach scrollTo(),
      // so honour it here too
      track.scrollTo({ left: track.clientWidth * i, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-index') || 0); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.getAttribute('data-index') || 0); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    // arrow keys page the gallery once it has focus
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(current - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); e.preventDefault(); }
    });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(last, i)));
      });
    }, { passive: true });
    setActive(0);
  });

  // ---- quantity steppers ----
  qa('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!input) return;
        var v = parseInt(input.value, 10) || 1;
        v = b.getAttribute('data-step') === 'up' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      });
    });
  });

  // ---- variant selection ----
  function money(cents) {
    var currency = window.JOIEX_CURRENCY || 'CAD';
    var locale = window.JOIEX_LOCALE || document.documentElement.lang || undefined;
    var value = cents / 100;
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value); }
    catch (e) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(value); }
      catch (e2) { return value.toFixed(2) + ' ' + currency; }
    }
  }
  qa('.product-form').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    function currentOptions() { return Array.prototype.map.call(selects, function (s) { return s.value; }); }
    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        var label = match.available
          ? (addBtn.getAttribute('data-label') || STR.addToCart)
          : (addBtn.getAttribute('data-sold-out-label') || STR.soldOut);
        if (label) addBtn.textContent = label;
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  // ---- header shadow on scroll (height never changes) ----
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---- links that open an accordion panel: <a data-open-acc="details-id"> ----
  document.addEventListener('click', function (e) {
    var t = e.target;
    var link = t && t.closest ? t.closest('a[data-open-acc]') : null;
    if (!link) return;
    var id = (link.getAttribute('data-open-acc') || '').replace(/^#/, '');
    var panel = id ? document.getElementById(id) : null;
    if (!panel || panel.tagName !== 'DETAILS') return;
    e.preventDefault();
    panel.open = true;
    var bar = document.getElementById('shopify-section-header') || header;
    var offset = (bar ? bar.getBoundingClientRect().height : 0) + 16;
    var top = Math.max(0, panel.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - offset);
    try { window.scrollTo({ top: top, behavior: prefersReducedMotion() ? 'instant' : 'smooth' }); }
    catch (err) { window.scrollTo(0, top); }
    focusEl(panel.querySelector('summary'));
  });
})();

/* ===== promo popups, wishlist heart, tilt ===== */
(function () {
  'use strict';
  var STR = window.JX_STR || {};
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canHover = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
  function qa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
  }
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trapTab(e, root) {
    if (e.key !== 'Tab' || !root) return;
    var items = qa(FOCUSABLE, root).filter(function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || !root.contains(active))) { focusEl(last); e.preventDefault(); }
    else if (!e.shiftKey && (active === last || !root.contains(active))) { focusEl(first); e.preventDefault(); }
  }

  // ---------- confetti ----------
  function confetti(host) {
    if (reduce || !host) return;
    var colors = ['#6B1D2C', '#A8354A', '#E8C4B8', '#F3D9A4', '#FAF5EE'];
    for (var i = 0; i < 24; i++) {
      var c = document.createElement('span');
      c.className = 'confetti';
      c.style.left = (10 + Math.random() * 80) + '%';
      c.style.background = colors[i % colors.length];
      c.style.animation = 'fall ' + (0.9 + Math.random() * 0.7) + 's ease-out forwards';
      c.style.animationDelay = (Math.random() * 0.2) + 's';
      host.appendChild(c);
      (function (el) { setTimeout(function () { el.remove(); }, 1900); })(c);
    }
  }

  // ---------- clipboard ----------
  function copyText(text, done) {
    function fallback() {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.left = '0'; ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (err) {}
      done();
    }
    if (navigator.clipboard && window.isSecureContext) { navigator.clipboard.writeText(text).then(done, fallback); }
    else { fallback(); }
  }

  // ---------- promo (scratch on home, slide-up elsewhere; first visit only) ----------
  var promo = document.querySelector('[data-promo]');
  if (promo) {
    var SEEN = 'joiex_promo_seen';
    var seen = false;
    try { seen = localStorage.getItem(SEEN) === '1'; } catch (e) {}
    var markSeen = function () { try { localStorage.setItem(SEEN, '1'); } catch (e) {} };

    var scratchModal = promo.querySelector('[data-promo-scratch]');
    var scratchDialog = scratchModal ? (scratchModal.querySelector('[role="dialog"]') || scratchModal) : null;
    var slideBar = promo.querySelector('[data-promo-slide]');
    var page = promo.getAttribute('data-page');
    var delaySetting = parseFloat(promo.getAttribute('data-delay'));
    var delay = (isNaN(delaySetting) ? 1 : Math.max(0, delaySetting)) * 1000;
    var promoReturnFocus = null;

    var isScratchOpen = function () { return !!(scratchModal && scratchModal.classList.contains('open')); };
    var isSlideOpen = function () { return !!(slideBar && slideBar.classList.contains('open')); };

    var closePromo = function () {
      var hadModal = isScratchOpen();
      if (scratchModal) scratchModal.classList.remove('open');
      if (slideBar) slideBar.classList.remove('open');
      markSeen();
      if (hadModal && promoReturnFocus && document.body.contains(promoReturnFocus)) focusEl(promoReturnFocus);
      promoReturnFocus = null;
    };

    qa('[data-promo-close]', promo).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closePromo(); });
    });
    if (scratchModal) scratchModal.addEventListener('click', function (e) { if (e.target === scratchModal) closePromo(); });
    // the mobile drawer (first block above) flags <html> while it is open
    var isDrawerOpen = function () { return document.documentElement.classList.contains('jx-drawer-open'); };
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // Escape that closed the drawer must not also dismiss the (hidden) slide-up bar
        if (e.defaultPrevented || isDrawerOpen()) return;
        if (isScratchOpen() || isSlideOpen()) closePromo();
        return;
      }
      if (isScratchOpen()) trapTab(e, scratchDialog);
    });

    // copy: keep open so they can read the code, but count as seen
    qa('[data-promo-copy]', promo).forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-code') || '';
        if (!b.hasAttribute('data-original-label')) b.setAttribute('data-original-label', b.textContent);
        copyText(code, function () {
          if (STR.copied) b.textContent = STR.copied;
          clearTimeout(b._jxCopyTimer);
          b._jxCopyTimer = setTimeout(function () { b.textContent = b.getAttribute('data-original-label'); }, 1600);
          focusEl(b);
        });
        markSeen();
      });
    });
    // slide-up email submit -> mark seen before navigation
    var slideForm = promo.querySelector('[data-promo-slide] form');
    if (slideForm) slideForm.addEventListener('submit', markSeen);

    // ---- scratch canvas ----
    var initScratch = function () {
      var canvas = promo.querySelector('[data-scratch-canvas]');
      if (!canvas || canvas.getAttribute('data-ready')) return;
      canvas.setAttribute('data-ready', '1');
      var ctx = canvas.getContext && canvas.getContext('2d');
      if (!ctx) return;
      var area = canvas.parentNode;
      var hint = promo.querySelector('[data-scratch-hint]');
      var revealed = false, drawing = false, last = 0, w = 0, h = 0;

      function paint() {
        // layout size, not the (possibly still scaling) on-screen rect
        w = area.clientWidth; h = area.clientHeight;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var g = ctx.createLinearGradient(0, 0, w, h);
        g.addColorStop(0, '#F3D9A4'); g.addColorStop(0.5, '#E8C4B8'); g.addColorStop(1, '#D9AFA8');
        ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
        var label = String(STR.scratchHere || '').toUpperCase();
        if (!label) return;
        ctx.fillStyle = 'rgba(26,18,16,.8)';
        ctx.font = '600 13px ' + getComputedStyle(document.body).fontFamily;
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        if ('letterSpacing' in ctx) { ctx.letterSpacing = '4px'; ctx.fillText(label, w / 2 + 2, h / 2); }
        else { ctx.fillText(label.split('').join(' '), w / 2, h / 2); }
      }
      paint();

      function pos(e) {
        var r = canvas.getBoundingClientRect();
        var t = e.touches ? e.touches[0] : e;
        var sx = r.width ? w / r.width : 1, sy = r.height ? h / r.height : 1;
        return { x: (t.clientX - r.left) * sx, y: (t.clientY - r.top) * sy };
      }
      function reveal() {
        if (revealed) return;
        revealed = true;
        canvas.style.transition = 'opacity .5s ease'; canvas.style.opacity = '0';
        setTimeout(function () { canvas.style.display = 'none'; }, 520);
        if (hint && STR.revealed) hint.textContent = STR.revealed;
        confetti(area);
      }
      function scratch(e) {
        if (!drawing || revealed) return;
        var p = pos(e);
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath(); ctx.arc(p.x, p.y, 20, 0, Math.PI * 2); ctx.fill();
        var now = Date.now(); if (now - last < 180) return; last = now;
        var img = ctx.getImageData(0, 0, canvas.width, canvas.height).data, clear = 0;
        for (var i = 3; i < img.length; i += 40) { if (img[i] === 0) clear++; }
        if (clear / (img.length / 40) > 0.5) reveal();
      }
      canvas.addEventListener('mousedown', function (e) { drawing = true; scratch(e); });
      window.addEventListener('mouseup', function () { drawing = false; });
      canvas.addEventListener('mousemove', scratch);
      canvas.addEventListener('touchstart', function (e) { drawing = true; scratch(e); e.preventDefault(); }, { passive: false });
      canvas.addEventListener('touchmove', function (e) { scratch(e); e.preventDefault(); }, { passive: false });
      canvas.addEventListener('touchend', function () { drawing = false; });
      if (reduce) reveal();
    };

    var openScratch = function () {
      if (!scratchModal) return;
      promoReturnFocus = document.activeElement;
      scratchModal.classList.add('open');
      initScratch();
      focusEl(scratchModal.querySelector('.close[data-promo-close]') || scratchDialog);
    };

    // after the slide-up form posts, the page reloads on #promo-slide-form: show the result
    var slideResult = slideBar && slideBar.querySelector('[data-promo-result]');
    if (slideResult && location.hash === '#promo-slide-form') {
      slideBar.classList.add('open');
    } else if (!seen) {
      // If the mobile drawer is open when the delay ends, wait until it closes:
      // the bar would cover the drawer's footer, and two focus traps would fight.
      var pendingPromo = false;
      var showPromo = function () {
        if (isDrawerOpen()) { pendingPromo = true; return; }
        pendingPromo = false;
        if (page === 'index' && scratchModal) openScratch();
        else if (slideBar) slideBar.classList.add('open');
      };
      document.addEventListener('jx:drawer', function (e) {
        if (!pendingPromo || (e.detail && e.detail.open)) return;
        // let the drawer finish sliding out first; showPromo re-checks in case it reopened
        setTimeout(function () { if (pendingPromo) showPromo(); }, reduce ? 0 : 380);
      });
      setTimeout(showPromo, delay);
    }
  }

  // ---------- wishlist heart (visual + localStorage) ----------
  var saved = {};
  try { saved = JSON.parse(localStorage.getItem('joiex_saved') || '{}') || {}; } catch (e) {}
  qa('[data-heart]').forEach(function (h) {
    var id = h.getAttribute('data-id');
    if (id && saved[id]) { h.classList.add('on'); h.setAttribute('aria-pressed', 'true'); }
    h.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var on = h.classList.toggle('on');
      h.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (id) { if (on) saved[id] = 1; else delete saved[id]; try { localStorage.setItem('joiex_saved', JSON.stringify(saved)); } catch (err) {} }
    });
  });

  // ---------- 3D tilt (desktop only; kept for any element still carrying data-tilt) ----------
  if (canHover && !reduce) {
    qa('[data-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'rotateY(' + px * 6 + 'deg) rotateX(' + (-py * 6) + 'deg) translateZ(0)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }
})();
